import { Heading2 } from "@/components/podkit/typography/Headings";
import { useListSSOConfigurations } from "@/queries/organization-queries";
import { BuiltinSSOConfigCard, CustomSSOConfigCard } from "@/routes/settings/login/SSOConfigCard";
import {
    SSOConfiguration_ProviderType,
    SSOConfigurationState,
    type SSOConfiguration,
} from "gitpod-next-api/gitpod/v1/organization_pb";
import { type FC } from "react";

export const LoginAndSecurity: FC<{ organizationId: string }> = ({ organizationId }) => {
    return (
        <div className="flex flex-col">
            <div className="flex h-full flex-col">
                <div className="text-base">Configure SSO for your organization.</div>
            </div>

            <LoginMethods organizationId={organizationId} />
        </div>
    );
};

const LoginMethods: FC<{ organizationId: string }> = ({ organizationId }) => {
    const { data: ssoConfigs } = useListSSOConfigurations();
    const builtinConfigs = ssoConfigs?.filter(isBuiltin) || [];
    const singleCustomConfig = ssoConfigs ? ssoConfigs.find(isCustom) : undefined;
    const hasSeveralActive =
        (ssoConfigs?.filter((c) => c.state === SSOConfigurationState.SSO_CONFIGURATION_STATE_ACTIVE)?.length || 0) > 1;
    const deactivateable = hasSeveralActive;

    return (
        <div className="mt-6 flex flex-col gap-6">
            <Heading2>Log in</Heading2>
            {builtinConfigs.map((config) => (
                <BuiltinSSOConfigCard
                    key={`built-in-config-${config.issuerUrl}`}
                    organizationId={organizationId}
                    config={config}
                    deactivateable={deactivateable}
                />
            ))}
            <CustomSSOConfigCard
                organizationId={organizationId}
                config={singleCustomConfig}
                deactivateable={deactivateable}
            />
        </div>
    );
};

const isCustom = (config: SSOConfiguration) => config.providerType === SSOConfiguration_ProviderType.CUSTOM;
const isBuiltin = (config: SSOConfiguration) => config.providerType === SSOConfiguration_ProviderType.BUILTIN;
